import constants from '../../constants';

export function getAuthToken() {
  try {
    const credentialsString = localStorage.getItem(constants.MACHADALO_LOCAL_STORAGE_CREDENTIALS_KEY);
    if (credentialsString) {
      const credentials = JSON.parse(credentialsString);
      if (credentials?.token) return credentials.token;
    }
  } catch (error) {
    console.warn('Failed to read machadalo-credentials token', error);
  }

  return localStorage.getItem(constants.MACHADALO_LOCAL_STORAGE_TOKEN_KEY) || '';
}

export function buildAuthenticatedWsUrl(basePath) {
  const baseUrl = process.env.REACT_APP_WEBSOCKET_URL || '';
  const normalizedBase = `${baseUrl}`.replace(/\/$/, '');
  const normalizedPath = `${basePath}`.startsWith('/') ? basePath : `/${basePath}`;
  const token = getAuthToken();

  if (!token) {
    return `${normalizedBase}${normalizedPath}`;
  }

  const separator = normalizedPath.includes('?') ? '&' : '?';
  return `${normalizedBase}${normalizedPath}${separator}token=${encodeURIComponent(token)}`;
}
